type BeepAnimationVariant = "emerald" | "red" | "blue" | 'yellow';

interface BeepAnimationProps {
    variant?: BeepAnimationVariant;
}

const VARIANT_CLASSES: Record<BeepAnimationVariant, string> = {
    emerald: "bg-emerald-500",
    red: "bg-red-500",
    blue: "bg-blue-500",
    yellow: "bg-yellow-500",
};

export default function BeepAnimation({ variant = "emerald" }: BeepAnimationProps) {
    const bgClass = VARIANT_CLASSES[variant];

    return (
        <span className="relative flex h-2 w-2">
            {/* pulse ring */}
            <span className={`absolute inline-flex h-full w-full animate-ping rounded-full ${bgClass}`} />

            {/* core dot */}
            <span className={`relative inline-flex h-2 w-2 rounded-full ${bgClass}`} />
        </span>
    );
}
